import React from 'react'
import { IconsModel } from './types/iconsModel'
import { gecinaBlueMain, WHITE } from '../theme'

const SvgDropDown = (
	{
		color = gecinaBlueMain,
		width = 46,
		height = 46,
		secondColor = WHITE
	}: IconsModel
) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 46.564 46.564">
		<g id="Groupe_897" data-name="Groupe 897" transform="translate(-853.141 -1867.671)">
			<circle id="Ellipse_267" data-name="Ellipse 267" cx="23.282" cy="23.282" r="23.282" transform="translate(899.705 1867.671) rotate(90)" fill={color} />
			<path id="Tracé_835" data-name="Tracé 835" d="M0,0,3.492,3.5,6.911,0" transform="translate(879.803 1892.223) rotate(180)" fill="none" stroke={secondColor} strokeLinecap="round" strokeWidth="2" />
		</g>
	</svg>

)

export default SvgDropDown